/* eslint-disable max-len */
const ErrorsMessages = Object.freeze({
  ERROR_DEVICE_STATUS_UPDATE: 'No se ha podido actualizar el estado del dispositivo.',
  ERROR_VISIBLE_PORTAL_COMPANIES: 'No se ha podido actualizar la visibilidad para el portal de empresas.',
  ERROR_FIELD_REQUIRED_FORMAT_EMAIL: 'Campo requerido o formato de email no válido',
  ERROR_FIELD_REQUIRED_FORMAT_NIF: 'Campo requerido o formato de NIF no válido',
  ERROR_FIELD_REQUIRED_FORMAT_NIF_NIE: 'Campo requerido o formato de NIF/NIE no válido',
  ERROR_FIELD_REQUIRED_FORMAT_SUPPORT_NUM: 'Campo requerido o formato de número de soporte no válido',
  ERROR_FIELD_REQUIRED_MIN_ROL: 'Campo requerido, mínimo un rol seleccionado',
  ERROR_FIELD_REQUIRED: 'Campo requerido',
  ERROR_FIELD_REQUIRED_DATE_AFTER: 'Campo requerido y la fecha debe ser posterior a la actual',
  ERROR_FIELD_REQUIRED_DATE_BEFORE: 'Campo requerido y la fecha debe ser anterior a la actual',
  ERROR_FIELDS_UNCHANGED: 'Los campos no han cambiado',
  ERROR_FIELD_POLICY: 'Debe aceptar la política de privacidad',
  ERROR_FILED_CHECK_MINOR: 'Debe de aceptar la tutolaridad del menor',
  ERROR_FORMAT_EMAIL: 'Formato de email no válido',
  ERROR_FORMAT_NIF: 'Formato de NIF no válido',
  ERROR_OPERATION: 'No se ha podido realizar la operación',
  ERROR_RESET_PASSWORD: 'No se ha podido restablecer la contraseña.',
  ERROR_UNEXPECTED: 'Ha ocurrido un error',
  ERROR_USER_REGISTER: 'No se ha podido registrar el usuario.',
  ERROR_USER_UPDATE_STATE: 'No se ha podido actualizar el estado del usuario.',
  ERROR_VALIDATION: 'Error de validación',
});

const SuccessMessages = Object.freeze({
  SUCCESS_DEVICE_STATUS_UPDATE: 'Estado del dispositivo actualizado con éxito',
  SUCCESS_VISIBLE_PORTAL_COMPANIES: 'Visibilidad para el portal de empresas actualizada con éxito',
  SUCCESS_OPERATION: 'Operación realizada',
  SUCCESS_RESET_PASSWORD: 'Contraseña restablecida con éxito',
  SUCCESS_USER_CREATE: 'Usuario registrado con éxito',
  SUCCESS_USER_DISABLE: 'Usuario deshabilitado con éxito',
  SUCCESS_USER_ENABLE: 'Usuario habilitado con éxito',
  SUCCESS_USER_UPDATE_STATE: 'Estado del usuario actualizado con éxito',
  SUCCESS_USER_UPDATE: 'Usuario actualizado con éxito',
});

const InfoMessages = Object.freeze({
  INFO_SENDING: 'Enviando...',
  INFO_USER_CREATE: 'Crear usuario',
  INFO_SAVE_CHANGES: 'Guardar cambios',
  INFO_USER_INTERNAL_CREATE: 'Crear usuario interno',
  INFO_USER_INTERNAL_EDIT: 'Editar usuario interno',
  INFO_USER_TERMINAL_CREATE: 'Crear usuario terminales',
  INFO_USER_TERMINAL_EDIT: 'Editar usuario terminales',
});

export {
  InfoMessages,
  ErrorsMessages,
  SuccessMessages,
};
